/*
 * Saracen Instagram videos — nekonečná (marquee) lišta 9:16 videí.
 * - Automatický plynulý posun; hover / dotyk ho pozastaví.
 * - Náhledy hrají ztlumené ve smyčce (jako IG reels); přehrávají se jen ta,
 *   která jsou vidět (IntersectionObserver — kvůli výkonu).
 * - Klik na video otevře lightbox s ozvučeným přehráváním.
 * - Respektuje prefers-reduced-motion (bez auto-posunu i bez autoplay).
 *
 * Kontejner: [data-ig-marquee] (+ data-speed), lišta: [data-ig-track],
 * slidy: [data-ig-slide], klikací prvek: [data-ig-open] s <video> uvnitř.
 */
(function () {
  // Sekce vkládá tento <script> při každém výskytu — spustit obsah jen jednou.
  // (init nových sekcí přidaných v editoru řeší listener shopify:section:load.)
  if (window.__saracenIgMarquee) return;
  window.__saracenIgMarquee = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Sdílený lightbox (jeden pro celou stránku) ---- */
  var lb = null;
  function ensureLightbox() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'ig-lightbox';
    lb.setAttribute('hidden', '');
    lb.innerHTML =
      '<div class="ig-lightbox__backdrop" data-ig-close></div>' +
      '<div class="ig-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Video">' +
      '<button class="ig-lightbox__close" type="button" data-ig-close aria-label="Zavřít">&times;</button>' +
      '<video class="ig-lightbox__video" controls playsinline preload="auto"></video>' +
      '<a class="ig-lightbox__link" target="_blank" rel="noopener" hidden>Otevřít na Instagramu</a>' +
      '</div>';
    document.body.appendChild(lb);

    lb.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-ig-close')) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lb.hasAttribute('hidden')) closeLightbox();
    });
    return lb;
  }

  var onLightboxClose = null;
  function openLightbox(sourceVideo, link, onClose) {
    ensureLightbox();
    var video = lb.querySelector('.ig-lightbox__video');
    video.innerHTML = '';
    Array.prototype.forEach.call(sourceVideo.querySelectorAll('source'), function (s) {
      var el = document.createElement('source');
      el.src = s.src || s.getAttribute('src');
      if (s.type) el.type = s.type;
      video.appendChild(el);
    });
    if (sourceVideo.getAttribute('poster')) video.setAttribute('poster', sourceVideo.getAttribute('poster'));

    var linkEl = lb.querySelector('.ig-lightbox__link');
    if (link) { linkEl.href = link; linkEl.hidden = false; } else { linkEl.hidden = true; }

    lb.removeAttribute('hidden');
    document.documentElement.classList.add('ig-lightbox-open');
    video.muted = false;
    video.currentTime = 0;
    video.load();
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
    onLightboxClose = onClose || null;
  }
  function closeLightbox() {
    if (!lb) return;
    var video = lb.querySelector('.ig-lightbox__video');
    video.pause();
    video.removeAttribute('src');
    video.innerHTML = '';
    lb.setAttribute('hidden', '');
    document.documentElement.classList.remove('ig-lightbox-open');
    if (onLightboxClose) { onLightboxClose(); onLightboxClose = null; }
  }

  /* ---- Marquee jedné sekce ---- */
  function setupMarquee(root) {
    if (root.dataset.igReady) return;
    var track = root.querySelector('[data-ig-track]');
    if (!track) return;
    var originals = Array.prototype.slice.call(track.querySelectorAll('[data-ig-slide]'));
    if (!originals.length) return;
    root.dataset.igReady = '1';

    var speed = (parseFloat(root.getAttribute('data-speed')) || 4) * 0.16; // px/frame

    // Klonujeme sady, dokud obsah nepřesáhne 2× viewport (bezešvá smyčka).
    function cloneSet() {
      originals.forEach(function (s) {
        var c = s.cloneNode(true);
        c.setAttribute('data-ig-clone', '');
        c.setAttribute('aria-hidden', 'true');
        track.appendChild(c);
      });
    }
    cloneSet();
    var guard = 0;
    while (track.scrollWidth < root.clientWidth * 2 && guard < 8) { cloneSet(); guard++; }

    var oneSet = 0;
    function measure() {
      var firstClone = track.querySelector('[data-ig-clone]');
      oneSet = firstClone ? firstClone.offsetLeft - originals[0].offsetLeft : 0;
    }

    // Přehráváme jen viditelná videa (výkon).
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { v.play().catch(function () {}); }
          else { v.pause(); }
        });
      }, { root: root, threshold: 0.15 });
      track.querySelectorAll('video').forEach(function (v) { v.muted = true; io.observe(v); });
    }

    // Auto-posun
    var hoverPaused = false;
    var lbPaused = false;
    function paused() { return reduce || hoverPaused || lbPaused; }

    var acc = 0; // scrollLeft prohlížeč čte celočíselně → posouváme jen po celých px
    function tick() {
      if (oneSet <= 0) measure(); // pojistka, kdyby měření proběhlo před layoutem
      if (!paused() && oneSet > 0) {
        acc += speed;
        var whole = Math.floor(acc);
        if (whole >= 1) {
          acc -= whole;
          track.scrollLeft += whole;
          if (track.scrollLeft >= oneSet) track.scrollLeft -= oneSet;
        }
      }
      requestAnimationFrame(tick);
    }

    // Ruční scroll dozadu taky zabalí
    track.addEventListener('scroll', function () {
      if (oneSet > 0 && track.scrollLeft <= 0) track.scrollLeft += oneSet;
    });

    root.addEventListener('mouseenter', function () { hoverPaused = true; });
    root.addEventListener('mouseleave', function () { hoverPaused = false; });
    // Dotyk: při ovládání prstem pauza, chvíli po puštění zase jede.
    var resumeTimer = null;
    root.addEventListener('touchstart', function () { hoverPaused = true; }, { passive: true });
    root.addEventListener('touchend', function () {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { hoverPaused = false; }, 2500);
    }, { passive: true });

    // Klik → lightbox
    track.addEventListener('click', function (e) {
      var card = e.target.closest('[data-ig-open]');
      if (!card) return;
      var video = card.querySelector('video');
      if (!video) return;
      lbPaused = true;
      openLightbox(video, card.getAttribute('data-ig-link') || '', function () { lbPaused = false; });
    });

    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    requestAnimationFrame(tick);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ig-marquee]').forEach(setupMarquee);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
